export default __webpack_public_path__ + "static/media/blue-plus-icon.d6b8e3b0.svg";